import gql from 'graphql-tag'

export const GRUPO_USUARIOS_QUERY = gql`
  query GetGrupoUsuariosQuery($id: ID!) {
    grupoUsuarios(id: $id) {
      id
      nome
      marcas {
        id
      }
      tiposUsuarios {
        id
      }
      usuariosManuais {
        id
        nome
        email
      }
      tiposAcesso {
        id
        produto {
          id
        }
      }
      criador {
        id
        nome
        email
        tipo {
          id
        }
      }
      dealers {
        id
        nomeExibicao
      }
      todosDealers
      possuiPerfil
      possuiUsuariosManuais
      active
      possuiCargos
      cargos {
        id
        nome
      }
      possuiSetores
      setores {
        id
        nome
      }
      publico
      possuiGrupos
      grupos {
        id
        nome
      }
      possuiDepartamentos
      departamentos {
        id
        nome
      }
    }
  }
`

export const grupoUsuarioByNomeGql = gql`
  query GetGrupoUsuarioByNomeQuery($nome: String!) {
    grupoUsuariosByNome(nome: $nome) {
      id
      nome
    }
  }
`
